module.exports = __webpack_public_path__ + "img/labo.bfffaa89.png";